
import { Popover, Box } from "@mui/material";

export default function ControlledPopover({ anchorEl, open, onClose, content }) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      PaperProps={{ sx: { p: 1, minWidth: 150 } }}
    >
      <Box>{content}</Box>
    </Popover>
  );
}
